import { render, staticRenderFns } from "./room_point.vue?vue&type=template&id=44b2321d&scoped=true&"
import script from "./room_point.vue?vue&type=script&lang=js&"
export * from "./room_point.vue?vue&type=script&lang=js&"
import style0 from "./room_point.vue?vue&type=style&index=0&id=44b2321d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b2321d",
  null
  
)

export default component.exports